import * as XLSX from 'xlsx';

/* Excel로 내보내기 함수 */
export const exportToExcel = (data, filename) => {
    /*Step 1: 새로운 workbook을 만든다.*/
    const wb = XLSX.utils.book_new();

    /*Step 2: 데이터 rows에 대한 value와 style을 지정한다.*/

    /* Step 3: row로 worksheet를 생성한다.*/
    const ws = XLSX.utils.json_to_sheet(data);

    /* wrapText 스타일 추가 */
    Object.keys(ws).forEach((cell) => {
        if (cell[0] === '!') return;    // skip metadata
        if (!ws[cell].s) ws[cell].s = {};
        ws[cell].s.alignment = {wrapText: true }; 
    });

    /* Step 4: worksheet를 workbook에 추가한다. */
    XLSX.utils.book_append_sheet(wb, ws, 'Spec Table');

    /* Step5: Excel 파일을 쓴다. */
    // XLSX.writeFile(wb, `Specification Table_${projectName}.xlsx`);
    XLSX.writeFile(wb, filename);
};

export const dataConvert = (conveyors) => {
    let data = [];
    conveyors.map((conveyor) => data.push(rowGenerate(conveyor)));
    return data;
};

const rowGenerate = (conveyor) => {
    const { belt, capacity, drive, driveComponent, idler, profile, pulley, resistance, tension } = conveyor.body;

    return {
        'BC\nNo.': `${conveyor.title}`,
        'H.L\n(m)': `${profile.horizontalLength}`,
        'V.L\n(m)': `${profile.verticalLift}`,
        'Capa\n(tph)': `${capacity.designCapacity}`,
        'Mat-\nerial': `${capacity.materialConveyed}`,
        'Density\n(kg/m3)': `${capacity.bulkDensity}`,
        'Sur-\ncharge\n(deg)': `${capacity.surchargeAngle}`,
        'Belt\nWidth\n(m)': `${capacity.beltWidth}`,
        'Speed\n(m/s)': `${capacity.beltSpeed}`,
        'Tractive\nPull\n(N)': `${resistance.tractivePull}`,
        'Drive\nEff.': `${drive.driveEfficiency}`,
        'Req.\nPower\n(kW)': `${drive.requiredPower}`,
        'Selc.\nMotor\n(kW)': `${drive.selectedMotor}`,
        Poles: `${drive.numberOfPoles}`,
        'Wrap\nAngle\n(deg)': `${tension.wrapAngle}`,
        'Lagging\nFrict.\nCoeff': `${tension.laggingFrictionCoeff}`,
        "Driv'g\nFactor": `${tension.drivingFactor[0]}`,
        'T1\n(N)': `${tension.tightSideTension}`,
        'T2\n(N)': `${tension.slackSideTension}`,
        'PIW\n(N/mm)': `${tension.PIW}`,
        'Selc.\nBelt': `${belt.selectedBelt}`,
        SF: `${tension.actualBeltSF}`,
        'Wb\n(kg/m)': `${belt.beltUnitMass}`,
        'Drive\nPulley\nDia(mm)': `${drive.drivePulleyDia}`,
        'Fluid\nCoup.': `${driveComponent?.fluidCoupling.model}`,
        'Gear\nCoup.': `${driveComponent?.gearCoupling.model}`,
        Brake: `${driveComponent?.brake.model}`,
        'Hold-\nback': `${driveComponent?.holdback.model}`,
        "Comp't\nWt(ton)": ``,
        'Strct.\nWt(ton)': ``,
    };
};

export const dataConvertTower = (towers) => {
    let data = [];
    towers.map((tower) => data.push(rowGeneratorTower(tower)));

    return data;
}

const rowGeneratorTower = (tower) => {
    const {} = tower.body;

    return {
        'Tower<br/>No.': `${tower.title}`,
        'Width (m)': `${tower.title}`,
        'Height (m)': `${tower.title}`,
        'No. of<br/>Drive<br/>Floor': `${tower.title}`,
        'No. of<br/>Non-Drive<br/>Floor': `${tower.title}`,
        'No. of<br/>Access Floor': `${tower.title}`,
        'Volume<br/>m3': `${tower.title}`,
        'Drive Floor<br/>Area(m2)': `${tower.title}`,
        'N.Drive Floor<br/>Area(m2)': `${tower.title}`,
        'Access Floor<br/>Area(m2)': `${tower.title}`,
        '': `${tower.title}`,
        'Floor Plate': `${tower.title}`,
        'Girth Area': `${tower.title}`,
        'Purlin Area': `${tower.title}`,
        'Roofing Area': `${tower.title}`,
        'Siding Area': `${tower.title}`,
        'Stair Height': `${tower.title}`,
        "Door Q'ty": `${tower.title}`,
        'Big Door': `${tower.title}`,
        'Hoist Beam': `${tower.title}`,
        'Drain Pipe': `${tower.title}`,
        'Etc.': `${tower.title}`,
        'H.T.Bolt/Nut': `${tower.title}`,
        "Anchor Bolt<br/>Embeded Mt'l": `${tower.title}`,
        Total: `${tower.title}`,
    };
};
